import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ReasonCodeMaintenanceModalComponent } from './reason-code-maintenance-modal.component';

@Injectable()
export class ReasonCodeMaintenanceModalService {

    constructor(private readonly dialog: MatDialog) { }

    showModal() {
        let dialogRef: MatDialogRef<ReasonCodeMaintenanceModalComponent>;

        dialogRef = this.dialog.open(
            ReasonCodeMaintenanceModalComponent,
            {
                disableClose: true,
                height: '94vh',
                panelClass: 'tprecm-modal-panel'
            }
        );

        return dialogRef;
    }
}
